import { get } from 'lodash-es'

import { Address, InPersonLocation } from '../../models'

export const formatAddressForSubmission = (address: Address | InPersonLocation) => {
  return [
    address.street1 || get(address, 'address1', ''),
    address.street2 ? address.street2 : '',
    address.city ?? '',
    address.state ?? '',
    address.zipcode ?? address.zip ?? '',
  ]
    .filter((address) => address !== '')
    .join(', ')
}
